module.exports = __webpack_public_path__ + "img/api_icon.05e90a74.svg";